import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/esnext.string.replace-all.js';
import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { onlyNumbers } from '@brazilian-utils/brazilian-utils';
import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client';
import { inject } from 'inversify';
import { GeneralError } from '../domain/errors/general.js';
import { Envs } from '../envs.js';

let SubmitAccountVerification = class SubmitAccountVerification {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(data) {
    return __awaiter(this, void 0, void 0, function* () {
      const response = yield this.httpClient.request({
        method: HttpMethod.POST,
        url: this.makeUrl(),
        body: this.makeBody(data)
      });
      if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
        return response.data;
      } else {
        /** @todo: Handle backend errors */
        throw new GeneralError();
      }
    });
  }
  makeBody(data) {
    return Object.assign(Object.assign({}, data), {
      businessOwner: Object.assign(Object.assign({}, data.businessOwner), {
        phoneNumber: data.businessOwner.phoneNumber.replaceAll('+', ''),
        documentNumber: onlyNumbers(data.businessOwner.documentNumber)
      }),
      bankAccount: data.bankAccount,
      isPixKey: data.isPixKey
    });
  }
  makeUrl() {
    return `${Envs.BFF_WEB_URL}/business`;
  }
};
SubmitAccountVerification = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], SubmitAccountVerification);

export { SubmitAccountVerification };
